<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

  
  <Sidebar variant="mobile" offcanvas_id="dashboardSidebarOffcanvas" />
<!-- Main area below navbar fills remaining height -->
  <div class="container-fluid flex-grow-1 overflow-hidden">
    <div class="row h-100">

      <!-- Sidebar column (same Sidebar component; no scrolling) -->
      <div v-if="show_sidebar" class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
        <div class="mt-2">
          <Sidebar ref="sidebar"></Sidebar>
        </div>
      </div>

      <!-- Content column (the ONLY scrollable area) -->
      <div class="col h-100 overflow-auto mt-2">
        <div class="bg-gray px-2 py-1 h-100 scrollable-container mb-5">
          <div class="card bg-transparent mt-3 rounded border-0">
            <div class="card-body">
            <button
          class="btn btn-light border rounded-circle d-inline-flex d-lg-none align-items-center justify-content-center p-0 dashboard-workspace-menu me-2 mb-2"
          type="button"
          data-bs-toggle="offcanvas"
          data-bs-target="#dashboardSidebarOffcanvas"
          aria-controls="dashboardSidebarOffcanvas"
          aria-label="Open workspace menu"
        >
          <i class="bx bx-menu-alt-left fs-5"></i>
        </button>

              <!-- Label and Add Button -->
              <div class="d-flex justify-content-between align-items-center mb-2">
                <label class="text-dark mb-1 fw-bold marketplace-toolbar-title">Membership Plan</label>

               <!-- Only show when there ARE memberships -->
              <div class="d-flex gap-2" v-if="memberships && memberships.length">
                <!-- Medium & up: open modal -->
                <button
                  v-can-create="'membership'"
                  class="btn btn-sm btn-primary text-xxs rounded shadow-sm"
                  data-bs-toggle="modal"
                  data-bs-target="#create_membership"
                  @click="open_create_membership_modal"
                  aria-label="Open create membership modal"
                >
                  Create Membership
                </button>
              </div>
            </div>

            <div class="row g-2 mb-3">
              <div
                v-for="card in membership_dashboard_cards"
                :key="card.label"
                class="col-6 col-md-4 col-xl"
              >
                <div class="dashboard-summary-card border rounded bg-white p-3 h-100 shadow-sm">
                  <div class="d-flex align-items-start justify-content-between gap-3 h-100">
                    <div class="d-flex flex-column justify-content-between h-100 min-w-0">
                      <div class="text-muted text-xxs fw-bold text-uppercase text-truncate">{{ card.label }}</div>
                      <div class="fw-bold text-dark h5 mb-0 mt-2">{{ card.value }}</div>
                    </div>
                    <span class="portal-dashboard-card-icon rounded-circle d-inline-flex align-items-center justify-content-center bg-light border flex-shrink-0">
                      <i class="bi" :class="[`text-${card.tone}`, card.icon]"></i>
                    </span>
                  </div>
                </div>
              </div>
            </div>


            <!-- Tab content -->
            <div class="tab-content" id="pills-tabContent">
              <div class="tab-pane fade active show" id="pills-subscriptions" role="tabpanel"
                aria-labelledby="pills-subscriptions-tab">

                <div v-if="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Membership List...</p>
            </div>
            <div v-else>
                <!-- Cards row -->
                <div v-if="memberships && memberships.length" class="row mt-4">
                  <div class="col-12 col-md-4 col-xl-3 mb-2 p-1" v-for="(membership, index) in memberships" :key="membership.id">
                    <div class="membership-plan-card d-flex flex-column h-100">
                      <div
                        class="card-body p-0 d-flex flex-column text-start cursor-pointer h-100"
                        role="button"
                        tabindex="0"
                        @click="open_manage_membership_modal(membership)"
                        @keydown.enter.prevent="open_manage_membership_modal(membership)"
                      >
                        <!-- Top section -->
                        <div class="membership-plan-card-header">
                          <div class="min-w-0">
                            <div class="membership-plan-title-row mb-2">
                              <h5 class="membership-plan-card-title mb-0 text-capitalize">
                                {{membership?.membership_type?.name}}
                              </h5>
                                <span
                                  class="membership-plan-status"
                                  :class="is_membership_published(membership) ? 'membership-plan-status-active' : 'membership-plan-status-inactive'"
                                >
                                  <span aria-hidden="true"></span>
                                  {{ is_membership_published(membership) ? 'Published' : 'Unpublished' }}
                                </span>
                            </div>
                            <p class="membership-plan-description mb-0" :title="membership.description">
                                  {{ membership.description?.length > 100 
                                    ? membership.description.substring(0, 100) + '...' 
                                    : membership.description || 'No description added yet.'
                                  }}
                            </p>
                          </div>
                          <div class="dropdown">
                            <button
                              class="membership-plan-menu-btn"
                              type="button"
                              data-bs-toggle="dropdown"
                              aria-expanded="false"
                              aria-label="Membership actions"
                              @click.stop
                            >
                              <i class="bi bi-three-dots-vertical"></i>
                            </button>
                            <ul class="dropdown-menu dropdown-menu-end">
                              <li>
                                <button
                                  class="dropdown-item text-xxs"
                                  type="button"
                                  data-bs-toggle="modal"
                                  data-bs-target="#create_membership"
                                  @click.stop.prevent="editMembership(membership)"
                                >Edit
                                </button>
                              </li>
                              <li>
                                <button
                                  class="dropdown-item text-xxs text-danger"
                                  type="button"
                                  @click.stop="delete_membership(membership.id)"
                                >Delete
                                </button>
                              </li>
                            </ul>
                          </div>
                        </div>

                        <!-- Grouped Info -->
                        <div class="membership-plan-card-body">
                          <div class="membership-plan-price-row">
                            <h4 class="membership-plan-price mb-0">
                              {{
                                (membership.membership_pricing || []).length > 0
                                  ? 'R ' + Number(membership.membership_pricing[0].price)
                                      .toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                  : 'N/A'
                              }}
                              <small>/{{ membership.billing_cycle?.name || '' }}</small>
                            </h4>
                            <span
                              class="membership-plan-subscriber-pill"
                            >
                              <i class="bi bi-people"></i>
                              <span>{{ membership.subscriber_count || 0 }} subscribers</span>
                            </span>
                          </div>

                          <div class="membership-plan-perks">
                            <div class="membership-plan-perks-header">
                              <div>
                                Perks & Benefits
                              </div>
                              <button
                                type="button"
                                class="membership-plan-perks-add"
                                title="Add perks"
                                aria-label="Add perks"
                                @click.stop="open_manage_perks_modal(membership.id)"
                              >
                                <i class="bi bi-plus-lg" aria-hidden="true"></i>
                              </button>
                            </div>
                            <div>
                              <ul class="list-unstyled mb-0">
                                <li v-if="membership.membership_perks && membership.membership_perks.length"
                                    v-for="perk in membership.membership_perks"
                                    :key="perk.id"
                                    class="membership-plan-perk">
                                  <i class="bi bi-check-circle-fill"></i>
                                  <span>{{ perk.perk.name }}</span>
                                </li>
                                <li v-else class="membership-plan-perk-empty">
                                  No perks added
                                </li>
                              </ul>
                            </div>
                          </div>
                        </div>

                        <!-- Action Buttons -->
                         <div class="membership-plan-actions">
                            <button
                              class="btn btn-sm membership-plan-action-primary rounded text-white w-100"
                              @click.stop="toggleMembership(membership)"
                            >
                              <i
                                class="bi me-1"
                              ></i>
                              {{ is_membership_published(membership) ? 'Unpublish' : 'Publish' }}
                            </button>
                            <button
                              type="button"
                              class="btn btn-sm membership-plan-action-secondary rounded text-white w-100"
                              @click.stop="open_manage_membership_modal(membership)"
                            >
                              Manage
                            </button>
                         </div>
                        <div class="d-none row g-2 align-items-center">

                          <!-- Activate -->
                          <div class=" col-6 col-sm-auto">
                            <button
                              class="btn btn-sm rounded px-2 text-xxs w-100"
                              :class="membership.is_active ? 'btn-outline-danger' : 'btn-outline-success'"
                              @click.stop="toggleMembership(membership)"
                            >
                              <i
                                class="bi me-1"
                                :class="membership.is_active ? 'bi-pause-circle' : 'bi-play-circle'"
                              ></i>
                              {{ membership.is_active ? 'Deactivate' : 'Activate' }}
                            </button>
                          </div>

                          <!-- View Details -->
                          <div class="col-6 col-sm-auto">
                            <button
                              class="btn btn-sm btn-primary rounded px-2 text-xxs w-100"
                              @click.stop="$router.push('view_membership_users/' + membership.id)"
                            >
                              View Details
                            </button>
                          </div>

                          <!-- Manage Perks -->
                          <div class="col-12 col-sm-auto">
                            <button
                              class="btn btn-sm btn-outline-secondary rounded px-2 text-xxs w-100"
                              data-bs-toggle="modal"
                              data-bs-target="#manage_perks_modal"
                              @click="open_manage_perks_modal(membership.id)"
                            >
                              Manage Perks
                            </button>
                          </div>

                        </div>

                      </div>
                    </div>
                  </div>
                </div>

                <!-- Empty state (only when no memberships) -->
                <div v-else class="text-center py-5 border rounded-3 bg-white">
                  <i class="bi bi-inbox fs-1 text-muted d-block mb-2" aria-hidden="true"></i>
                  <div class="mb-1">No memberships yet</div>
                  <div class="small text-muted mb-2">Create a membership to get started.</div>
                  <button v-can-create="'membership'" class="btn btn-primary btn-sm text-xxs"
                          data-bs-toggle="modal" data-bs-target="#create_membership"
                          @click="open_create_membership_modal">
                    Create Membership
                  </button>
                </div>
            </div>

                <!-- End cards row -->

              </div>
            </div>
          </div>
        </div>
      </div>
        <!-- Modal for Creating Membership -->
        <div class="modal fade" id="create_membership" tabindex="-1" aria-labelledby="createMembershipLabel"
          aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable modal-fullscreen-sm-down">
            <div class="modal-content rounded shadow-lg">
              <div class="modal-header border-0 shadow-sm">
                <h5 id="createMembershipLabel" class="modal-title text-xs">
                  {{ editing_membership_id ? 'Update Membership' : 'Create Membership' }}
                </h5>
                <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close"></button>
              </div>
              <form @submit.prevent="submit_membership_form(false)">
                <div class="modal-body modal-body-scroll px-4 pt-3 pb-4">
                   <!-- Membership Type -->
                  <div class="mb-3">
                    <label for="membership_type" class="form-label fw-bold">
                      Membership Type <span class="text-danger">*</span>
                    </label>
                    <div class="position-relative">
                      <input
                        type="text"
                        class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                        id="membership_type"
                        v-model="membership_type"
                        placeholder="Type or select a membership type"
                        :disabled="Boolean(editing_membership_id)"
                        @focus="show_membership_type_dropdown = true"
                        @input="on_membership_type_input"
                        @blur="show_membership_type_dropdown = false"
                        autocomplete="off"
                      />
                      <ul
                        class="dropdown-menu w-100 max-h-200"
                        :class="{ show: !editing_membership_id && show_membership_type_dropdown && get_filtered_membership_types(membership_type).length }"
                        v-if="!editing_membership_id && show_membership_type_dropdown"
                      >
                        <li
                          v-for="type in get_filtered_membership_types(membership_type)"
                          :key="type.id"
                        >
                          <button
                            class="dropdown-item text-xxs"
                            type="button"
                            @mousedown.prevent="select_membership_type(type)"
                          >
                            {{ type.name }}
                          </button>
                        </li>
                      </ul>
                    </div>

                    <!-- Error display -->
                    <p v-if="errors.membership_type" class="text-danger text-xxs">
                      {{ errors.membership_type }}
                    </p>
                  </div>
                  <!--Description-->
                  <div class="mb-3">
                    <label for="membership_description" class="form-label fw-bold">Description</label>
                    <textarea class="form-control rounded border-light-subtle px-3 py-2 text-xxs" id="membership_description"
                      v-model="membership_description" placeholder="Enter description"></textarea>
                  </div>

                  <!-- Membership Pricing -->
                  <div class="mb-3">
                    <label for="membership_price" class="form-label fw-bold">
                      Membership Price <span class="text-danger">*</span>
                    </label>
                    <input type="number" class="form-control rounded border-light-subtle px-3 py-2 text-xxs" id="membership_price"
                      v-model="membership_price" placeholder="Enter price" min="0"
                      :disabled="editing_membership_id && get_total_paid_users(editing_membership_id)">
                    <p v-if="errors.membership_price" class="text-danger text-xxs">{{ errors.membership_price
                      }}</p>
                  </div>

                  <!-- Biliiling cycle -->
                  <div class="mb-3">
                    <label for="billing_cycle" class="form-label fw-bold">
                      Billing type choices <span class="text-danger">*</span>
                    </label>
                    <select class="form-select rounded border-light-subtle px-3 py-2 text-xxs" id="billing_cycle" v-model="billing_cycle">
                      <option selected hidden>Select membership type</option>
                      <option v-for="billing_cycle in billing_cycle_choices" :key="billing_cycle.id"
                        :value="billing_cycle.id">
                        {{ billing_cycle.name }}
                      </option>
                    </select>
                    <p v-if="errors.billing_cycle" class="text-danger text-xxs">{{ errors.billing_cycle
                      }}</p>
                  </div>

                  <div class="mb-3">
                    <label for="membership_perk" class="form-label fw-bold">
                      Perks & Benefits
                    </label>
                    <div class="d-flex gap-2 mb-2">
                      <input
                        id="membership_perk"
                        v-model="new_perk_name"
                        type="text"
                        class="form-control rounded border-light-subtle px-3 py-2 text-xxs"
                        placeholder="Enter a perk"
                        @keyup.enter.prevent="add_perk_input"
                      />
                      <button type="button" class="btn btn-primary rounded text-xxs" @click="add_perk_input">
                        Add
                      </button>
                    </div>
                    <div
                      v-for="(perk, index) in membership_perks"
                      :key="perk.id || `new-perk-${index}`"
                      class="d-flex align-items-center gap-2 mb-2"
                    >
                      <input v-model="perk.perk" type="text" class="form-control rounded border-light-subtle px-3 py-2 text-xxs" />
                      <button
                        type="button"
                        class="btn btn-light board-icon-btn"
                        aria-label="Remove perk"
                        @click="remove_perk(index)"
                      >
                        <i class="bi bi-x-lg fs-6"></i>
                      </button>
                    </div>
                  </div>
                </div>
                <div class="modal-footer border-top bg-white shadow-sm px-4 py-3 d-flex gap-2">
                  <button
                    v-if="editing_membership_id"
                    type="submit"
                    class="btn btn-sm btn-primary text-xs rounded flex-fill"
                    :disabled="isSubmitting"
                  >
                    Update Membership
                  </button>
                  <template v-else>
                    <button
                      type="button"
                      class="btn btn-sm text-xs btn-outline-primary rounded flex-fill"
                      :disabled="isSubmitting"
                      @click="submit_membership_form(false)"
                    >
                      <span v-if="membership_submit_action === 'draft'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Saving...
                      </span>
                      <span v-else>
                        Save as Draft
                      </span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-sm text-xs btn-primary rounded flex-fill"
                      :disabled="isSubmitting"
                      @click="submit_membership_form(true)"
                    >
                      <span v-if="membership_submit_action === 'publish'">
                        <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                        Publishing...
                      </span>
                      <span v-else>
                        Publish
                      </span>
                    </button>
                  </template>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div class="modal fade" id="manage_perks_modal" tabindex="-1" aria-labelledby="manage_perks_modal" aria-hidden="true">
          <div class="modal-dialog modal-dialog-centered modal-dialog-scrollable mx-auto marketplace-modal-dialog">
            <div class="modal-content rounded-5 overflow-hidden border-0 shadow-lg marketplace-modal-surface">
              <div class="modal-header d-flex justify-content-start border-0 bg-black position-relative z-index-10">
                <div class="w-100 text-center">
                  <p class="modal-title text-xxs fw-500">Manage Perks</p>
                </div>
                
                <button
                  type="button"
                  class="btn p-0 border-0 shadow-none d-flex align-items-center justify-content-center modal-close-btn ms-auto"
                  data-bs-dismiss="modal"
                  aria-label="Close">
                  <i class="fas fa-times fs-6"></i>
                </button>
              </div>
              <div class="modal-body">
                <label class="form-label mb-3 text-xxs">Perk Name</label>

                <form class="d-flex align-items-stretch gap-1 mb-3" @submit.prevent="add_perk_input">
                  <input
                    type="text"
                    class="form-control rounded text-xxs"
                    v-model="new_perk_name"
                    placeholder="Earn Starbucks Coffee"
                  >
                  <button
                    type="submit"
                    class="btn btn-primary btn-sm text-xxs rounded px-4"
                  >
                    Add
                  </button>
                </form>

                <div class="border rounded p-2 bg-gray">
                  <div v-if="membership_perks.length > 0">
                    <div v-for="(perk, index) in membership_perks" :key="index" class="d-flex align-items-stretch gap-1 mb-2">
                      <input
                        type="text"
                        class="form-control rounded text-xxs"
                        v-model="perk.perk"
                        placeholder="Earn Starbucks Coffee"
                      >
                      <button
                        type="button"
                        class="btn btn-light board-icon-btn d-none d-xl-flex align-items-center justify-content-center me-2"
                        @click="remove_perk(index)"
                      >
                                            <i class="bi bi-x-lg" aria-hidden="true"></i>

                      </button>
                    </div>
                  </div>

                  <div v-else>
                    <p class="text-muted text-xxs mb-0 text-center">No perks available.</p>
                  </div>
                </div>
              </div>

              <div class="modal-footer">
                <button type="button" class="btn btn-primary btn-sm text-xxs rounded" @click="save_perks_function">
                  Save
                </button>
              </div>
            </div>
          </div>
        </div>

        <div
          class="modal fade"
          id="manage_membership_modal"
          tabindex="-1"
          aria-labelledby="manageMembershipModalLabel"
          aria-hidden="true"
        >
          <div class="modal-dialog modal-dialog-centered modal-lg modal-dialog-scrollable">
            <div class="modal-content rounded shadow-lg">
              <div class="modal-header border-0 shadow-sm">
                <h5 id="manageMembershipModalLabel" class="modal-title text-xs">
                  Manage Membership
                </h5>
                <button type="button" class="btn-close btn-close-black text-xs" data-bs-dismiss="modal" aria-label="Close" @click="close_manage_membership_modal"></button>
              </div>

              <div class="modal-body manage-product-modal-body modal-body-scroll">
                <div class="row g-4 align-items-stretch" v-if="selected_manage_membership">
                  <div class="col-12 col-lg-6">
                    <div class="border rounded p-3 bg-light-subtle h-100">
                      <div>
                        <div class="d-flex align-items-center gap-3 mb-4">
                          <div
                            class="d-flex align-items-center justify-content-center rounded-circle bg-light text-primary flex-shrink-0 image-preview-box"
                          >
                            <i class="bi bi-gem fs-4"></i>
                          </div>
                          <div>
                            <h4 class="fw-bold mb-1">
                              {{ selected_manage_membership?.membership_type?.name || selected_manage_membership?.name }}
                            </h4>
                          </div>
                        </div>

                        <p class="text-muted text-xxs lh-lg mb-4">
                          {{ selected_manage_membership.description || 'No description added yet.' }}
                        </p>

                        <div class="mb-4">
                          <h3 class="fw-bold text-primary mb-0">
                            {{
                              (selected_manage_membership.membership_pricing || []).length > 0
                                ? 'R ' + Number(selected_manage_membership.membership_pricing[0].price).toLocaleString('en-ZA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
                                : 'N/A'
                            }}
                            <small class="text-muted text-xxs fw-normal">
                              / {{ selected_manage_membership.billing_cycle?.name || 'Not set' }}
                            </small>
                          </h3>
                        </div>

                        <div class="bg-light rounded-3 px-3 py-3 mt-auto">
                          <div class="d-flex justify-content-between align-items-center text-xxs">
                            <span class="text-muted">Billing type</span>
                            <span class="fw-500 text-dark">{{ selected_manage_membership.billing_cycle?.name || 'Not set' }}</span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-12 col-lg-6">
                    <div class="border rounded p-3 h-100">
                      <div class="d-flex flex-wrap align-items-center justify-content-between gap-2 mb-3">
                        <div>
                          <h6 class="fw-bold mb-1 text-xxs">Membership details</h6>
                          <p class="text-muted text-xxs mb-0">
                            Review the membership information below.
                          </p>
                        </div>
                      </div>

                      <div class="mt-4">
                        <div class="mb-4">
                        <h6 class="fw-bold text-xxs">Membership performance</h6>
                        <div class="d-flex align-items-center cursor-pointer" @click="open_manage_membership_users(selected_manage_membership)">
                          <p class="fw-semibold text-xxs mb-0 text-muted">
                          Subscribers: {{ get_total_paid_users(selected_manage_membership.id) }}
                          </p>
                        </div>
                        </div>
                        <div class="mb-4">
                          <h6 class="fw-bold mb-2 text-xxs">Membership type</h6>
                          <p class="fw-semibold text-muted mb-0 text-xxs">
                            {{ selected_manage_membership?.membership_type?.name || 'Not set' }}
                          </p>
                        </div>

                        <div class="mb-4">
                          <h6 class="fw-bold mb-2 text-xxs">Status</h6>
                          <p class="fw-semibold text-muted text-xxs mb-0">
                            {{ selected_manage_membership.is_active ? 'Active' : 'Inactive' }}
                          </p>
                        </div>


                        <div class="mb-2">
                          <h6 class="fw-bold mb-2 text-xxs">Perks & Benefits</h6>
                          <div>
                            <ul class="list-unstyled mb-0">
                              <li
                                v-if="selected_manage_membership.membership_perks && selected_manage_membership.membership_perks.length"
                                v-for="perk in selected_manage_membership.membership_perks"
                                :key="perk.id"
                                class="mb-2 text-xxs"
                              >
                                <i class="bi bi-check-circle-fill text-primary me-2"></i>
                                {{ perk.perk.name }}
                              </li>
                              <li v-else class="text-muted text-xxs fst-italic">No perks added</li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div class="modal-footer manage-product-modal-footer d-flex gap-2 border-top bg-white">
                <div class="d-flex gap-2 w-100">
                  <button
                    type="button"
                    class="btn btn-sm btn-primary rounded flex-fill"
                    :disabled="!selected_manage_membership"
                    @click="selected_manage_membership && open_manage_membership_users(selected_manage_membership)"
                  >
                    View Details
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary rounded flex-fill"
                    :disabled="!selected_manage_membership"
                    @click="selected_manage_membership && open_manage_membership_perks(selected_manage_membership)"
                  >
                    Manage Perks
                  </button>
                  <button
                    type="button"
                    class="btn btn-sm btn-primary rounded flex-fill"
                    :disabled="!selected_manage_membership"
                    @click="selected_manage_membership && open_manage_membership_users(selected_manage_membership)"
                  >
                    Manage Subscribers
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</div>
